import {combineReducers} from 'redux';
import {getSuccessActionType} from '../utils';
import {getErrorReducer, getStatusReducer} from './utils/generators';
import {FETCH_STUDENT_COURSES} from '../constants/student-course';
import {END_STUDENT_COURSE, START_STUDENT_COURSE} from '../constants/student-course';

function data(state = {}, action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_STUDENT_COURSES):
      return action.payload;

    case getSuccessActionType(START_STUDENT_COURSE):
      return state.map(studentCourse =>
        (studentCourse.id === action.data.studentCourseId) ? action.payload : studentCourse
      );

    case getSuccessActionType(END_STUDENT_COURSE):
      return state.filter(studentCourse => (studentCourse.id !== action.data.studentCourseId));

    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_STUDENT_COURSES]),
  error: getErrorReducer([FETCH_STUDENT_COURSES]),
  data
});
